// app/redux/actions/paramCongesActions.js

// =========================
// FETCH ALL
// =========================
export const FETCH_PARAM_CONGES_REQUEST = "FETCH_PARAM_CONGES_REQUEST";
export const FETCH_PARAM_CONGES_SUCCESS = "FETCH_PARAM_CONGES_SUCCESS";
export const FETCH_PARAM_CONGES_FAIL = "FETCH_PARAM_CONGES_FAIL";

// =========================
// TYPES D'ABSENCES
// =========================
export const CREATE_ABSENCE_TYPE_REQUEST = "CREATE_ABSENCE_TYPE_REQUEST";
export const CREATE_ABSENCE_TYPE_SUCCESS = "CREATE_ABSENCE_TYPE_SUCCESS";
export const CREATE_ABSENCE_TYPE_FAIL = "CREATE_ABSENCE_TYPE_FAIL";

export const UPDATE_ABSENCE_TYPE_REQUEST = "UPDATE_ABSENCE_TYPE_REQUEST";
export const UPDATE_ABSENCE_TYPE_SUCCESS = "UPDATE_ABSENCE_TYPE_SUCCESS";
export const UPDATE_ABSENCE_TYPE_FAIL = "UPDATE_ABSENCE_TYPE_FAIL";

export const DELETE_ABSENCE_TYPE_REQUEST = "DELETE_ABSENCE_TYPE_REQUEST";
export const DELETE_ABSENCE_TYPE_SUCCESS = "DELETE_ABSENCE_TYPE_SUCCESS";
export const DELETE_ABSENCE_TYPE_FAIL = "DELETE_ABSENCE_TYPE_FAIL";

// =========================
// REGLES D'ACQUISITION
// =========================
export const CREATE_ACQ_RULE_REQUEST = "CREATE_ACQ_RULE_REQUEST";
export const CREATE_ACQ_RULE_SUCCESS = "CREATE_ACQ_RULE_SUCCESS";
export const CREATE_ACQ_RULE_FAIL = "CREATE_ACQ_RULE_FAIL";

export const UPDATE_ACQ_RULE_REQUEST = "UPDATE_ACQ_RULE_REQUEST";
export const UPDATE_ACQ_RULE_SUCCESS = "UPDATE_ACQ_RULE_SUCCESS";
export const UPDATE_ACQ_RULE_FAIL = "UPDATE_ACQ_RULE_FAIL";

export const DELETE_ACQ_RULE_REQUEST = "DELETE_ACQ_RULE_REQUEST";
export const DELETE_ACQ_RULE_SUCCESS = "DELETE_ACQ_RULE_SUCCESS";
export const DELETE_ACQ_RULE_FAIL = "DELETE_ACQ_RULE_FAIL";

// =========================
// JUSTIFICATIFS
// =========================
export const CREATE_JUSTIF_RULE_REQUEST = "CREATE_JUSTIF_RULE_REQUEST";
export const CREATE_JUSTIF_RULE_SUCCESS = "CREATE_JUSTIF_RULE_SUCCESS";
export const CREATE_JUSTIF_RULE_FAIL = "CREATE_JUSTIF_RULE_FAIL";

export const UPDATE_JUSTIF_RULE_REQUEST = "UPDATE_JUSTIF_RULE_REQUEST";
export const UPDATE_JUSTIF_RULE_SUCCESS = "UPDATE_JUSTIF_RULE_SUCCESS";
export const UPDATE_JUSTIF_RULE_FAIL = "UPDATE_JUSTIF_RULE_FAIL";

export const DELETE_JUSTIF_RULE_REQUEST = "DELETE_JUSTIF_RULE_REQUEST";
export const DELETE_JUSTIF_RULE_SUCCESS = "DELETE_JUSTIF_RULE_SUCCESS";
export const DELETE_JUSTIF_RULE_FAIL = "DELETE_JUSTIF_RULE_FAIL";

// =========================
// LOADING / ERROR
// =========================
export const SET_PARAM_CONGES_LOADING = "SET_PARAM_CONGES_LOADING";
export const CLEAR_PARAM_CONGES_ERROR = "CLEAR_PARAM_CONGES_ERROR";


/* =========================
   BULK IMPORT (EXCEL)
========================= */

// Download templates

// Clear review

// Action creators


// =========================
// ACTION CREATORS
// =========================

export const setParamCongesLoading = (loading) => ({
    type: SET_PARAM_CONGES_LOADING,
    payload: loading,
});

export const clearParamCongesError = () => ({
    type: CLEAR_PARAM_CONGES_ERROR,
});

// FETCH ALL
export const fetchParamCongesRequest = () => ({ type: FETCH_PARAM_CONGES_REQUEST });
export const fetchParamCongesSuccess = (data) => ({ type: FETCH_PARAM_CONGES_SUCCESS, payload: data });
export const fetchParamCongesFail = (error) => ({ type: FETCH_PARAM_CONGES_FAIL, payload: error });

// TYPES
export const createAbsenceTypeRequest = (payload) => ({ type: CREATE_ABSENCE_TYPE_REQUEST, payload });
export const createAbsenceTypeSuccess = (created) => ({ type: CREATE_ABSENCE_TYPE_SUCCESS, payload: created });
export const createAbsenceTypeFail = (error) => ({ type: CREATE_ABSENCE_TYPE_FAIL, payload: error });

export const updateAbsenceTypeRequest = (id, payload) => ({
    type: UPDATE_ABSENCE_TYPE_REQUEST,
    payload: { id, payload }
});
export const updateAbsenceTypeSuccess = (updated) => ({ type: UPDATE_ABSENCE_TYPE_SUCCESS, payload: updated });
export const updateAbsenceTypeFail = (error) => ({ type: UPDATE_ABSENCE_TYPE_FAIL, payload: error });

export const deleteAbsenceTypeRequest = (id) => ({ type: DELETE_ABSENCE_TYPE_REQUEST, payload: id });
export const deleteAbsenceTypeSuccess = (id) => ({ type: DELETE_ABSENCE_TYPE_SUCCESS, payload: id });
export const deleteAbsenceTypeFail = (error) => ({ type: DELETE_ABSENCE_TYPE_FAIL, payload: error });

// ACQUISITION
export const createAcqRuleRequest = (payload) => ({ type: CREATE_ACQ_RULE_REQUEST, payload });
export const createAcqRuleSuccess = (created) => ({ type: CREATE_ACQ_RULE_SUCCESS, payload: created });
export const createAcqRuleFail = (error) => ({ type: CREATE_ACQ_RULE_FAIL, payload: error });

export const updateAcqRuleRequest = (id, payload) => ({
    type: UPDATE_ACQ_RULE_REQUEST,
    payload: { id, payload }
});
export const updateAcqRuleSuccess = (updated) => ({ type: UPDATE_ACQ_RULE_SUCCESS, payload: updated });
export const updateAcqRuleFail = (error) => ({ type: UPDATE_ACQ_RULE_FAIL, payload: error });

export const deleteAcqRuleRequest = (id) => ({ type: DELETE_ACQ_RULE_REQUEST, payload: id });
export const deleteAcqRuleSuccess = (id) => ({ type: DELETE_ACQ_RULE_SUCCESS, payload: id });
export const deleteAcqRuleFail = (error) => ({ type: DELETE_ACQ_RULE_FAIL, payload: error });

// JUSTIFICATIFS
export const createJustifRuleRequest = (payload) => ({ type: CREATE_JUSTIF_RULE_REQUEST, payload });
export const createJustifRuleSuccess = (created) => ({ type: CREATE_JUSTIF_RULE_SUCCESS, payload: created });
export const createJustifRuleFail = (error) => ({ type: CREATE_JUSTIF_RULE_FAIL, payload: error });

export const updateJustifRuleRequest = (id, payload) => ({
    type: UPDATE_JUSTIF_RULE_REQUEST,
    payload: { id, payload }
});
export const updateJustifRuleSuccess = (updated) => ({ type: UPDATE_JUSTIF_RULE_SUCCESS, payload: updated });
export const updateJustifRuleFail = (error) => ({ type: UPDATE_JUSTIF_RULE_FAIL, payload: error });

export const deleteJustifRuleRequest = (id) => ({ type: DELETE_JUSTIF_RULE_REQUEST, payload: id });
export const deleteJustifRuleSuccess = (id) => ({ type: DELETE_JUSTIF_RULE_SUCCESS, payload: id });
export const deleteJustifRuleFail = (error) => ({ type: DELETE_JUSTIF_RULE_FAIL, payload: error });
